import { useCallback, useState } from 'react';
import Input from '../../../form/Input';
import { PRef } from '../ProductCreate';

/**
 * @author taulmax
 * @createDate 2024.10.26
 * @description 상품 등록 페이지 - 상품 코드
 */
const PCode = ({ pRef }: PRef) => {
  const [pCode, setPCode] = useState<string>('');
  const onChangePCode = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setPCode(value);
    },
    []
  );

  return (
    <Input
      inputRef={pRef}
      value={pCode}
      onChange={onChangePCode}
      textAlign="left"
      placeholder="예: SAJU-001"
      style={{ width: '100%' }}
    />
  );
};

export default PCode;
